import React, { type MouseEvent, type ReactElement } from 'react';

import { Icon } from '../Icon';
import { IconButton } from '../IconButton';

import { type TableResourceRecord } from './Table.types';

import styles from './Table.module.scss';

export type ExpandButtonProps<RecordType = unknown> = {
    record: RecordType;
    isExpanded: boolean;
    onTriggerExpand: (record: RecordType, event: MouseEvent<HTMLElement>) => void;
};

export const ExpandButton = <RecordType extends TableResourceRecord = any>({
    record,
    isExpanded,
    onTriggerExpand
}: ExpandButtonProps<RecordType>): ReactElement => {
    return (
        <IconButton
            color="neutral"
            type="ghost"
            size="medium"
            onClick={(e: MouseEvent<HTMLElement>) => onTriggerExpand(record, e)}
            aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
        >
            <Icon
                className={styles.expandIcon}
                name={isExpanded ? 's-icon-arrow-chevron-up' : 's-icon-arrow-chevron-down'}
            />
        </IconButton>
    );
};
